import React, { useEffect, useState } from 'react';
import { Modal, Skeleton } from 'antd';
import './complexity-analysis-modal.css';
import { analyzeCodeComplexity } from './complexity-analysis-api'
import { trackEvent } from "../../utils/util-functions";
import ReactMarkdown from "react-markdown";

const ComplexityModal = ({ isModalVisible, handleOk, handleCancel, ideProjectId, selectedFileId, ideProjectStackName }) => {
  const [complexityObj, setComplexityObj] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const analyseComplexity = async() => {
      
      if (ideProjectId && selectedFileId) {

        const reqObj = {
          ideProjectId,
          fileId: selectedFileId.id
        };

        setIsLoading(true);

        trackEvent("ide_analyse_complexity_button_clicked", {
          ide_project_stack_name: ideProjectStackName
        });

        const response = await analyzeCodeComplexity(reqObj);
        setIsLoading(false);

        if (response.data.statusCode === 200) {
          setComplexityObj(response.data.response)
        }
      }
    }
    if (isModalVisible) {
      analyseComplexity()
    }
    
  }, [isModalVisible, ideProjectId, selectedFileId, ideProjectStackName ]);


  return (
    
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      className='custom-modal'
      destroyOnClose={true}
      centered 
    >

      <div className="complexity-wrapper">
        {!isLoading && (
          <>
            <div>
              <strong style={{ fontSize: '17px', paddingTop: '5px' }}>
                Complexity&nbsp;
                <hr style={{marginTop: '0px'}}/>
              </strong>

          </div>
            <table style={{ width: '100%', border:'1px solid grey', marginTop:'17px' }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: 'bold', padding: '10px', border:'1px solid #eeeeee' }}>Time Complexity</td>
              <td style={{ fontWeight: 'bold', padding: '10px', border:'1px solid #eeeeee' }}>{complexityObj.timeComplexity}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: 'bold', padding: '10px', border:'1px solid #eeeeee' }}>Space Complexity</td>
              <td style={{ fontWeight: 'bold', padding: '10px', border:'1px solid #eeeeee' }}>{complexityObj.spaceComplexity}</td>
            </tr>
          </tbody>
        </table>

          <div style={{marginTop: '17px'}}>
            <strong style={{fontSize: '17px'}}>Explanation</strong>
            <hr style={{marginTop: '0px'}}/>
          </div>

        <div className='complexity-explanation' style={{ color: 'black' }}>
          <ReactMarkdown className="markdown">
            { complexityObj.explanation }
          </ReactMarkdown>
        </div>
          </>
        )}
        {isLoading && <Skeleton active />}
      </div>
    </Modal>
  );
};

export default ComplexityModal;
